import {
    DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_FAILURE,
    DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_FAILURE
  } from "../types/delivery-challan-register-gray-report-types";
  
  const initialState = {
    deliveryChallanGrayReports: {},
    loading: false,
    error: null,
  };
  
  const deliveryChallanGrayReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_REQUEST: 
      case DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterGrayReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterGrayFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_GRAY_REPORT_FAILURE :
      case DELIVERY_CHALLAN_REGISTER_GRAY_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default deliveryChallanGrayReportReducer;
  